export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/paypal.40892803.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};